<nav [style.margin-left]="getPosition()">
  <graphic *ngFor="let item of items; let imageNum = index" [src]="item.thumbnail" (click)="setImage(imageNum)" [class.current]="imageNum === index" [lazy]="false"></graphic>
</nav>
